import Helmet from 'react-helmet'
import Banner from '../../components/Banner'
import MainImage from '../../assets/community/main-image.webp'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
import { Link } from 'react-router-dom'
import BenefitImage2 from '../../assets/benefits/win.webp'
import BenefitImage3 from '../../assets/benefits/chia.webp'
import BenefitImage4 from '../../assets/benefits/ahimsa.webp'
import BenefitImage5 from '../../assets/benefits/parma.webp'
import BenefitImage6 from '../../assets/benefits/volver-a-casa.webp'
import BenefitImage7 from '../../assets/benefits/chillout.webp'
import BenefitImage8 from '../../assets/benefits/la-vianderita.webp'
import BenefitImage9 from '../../assets/benefits/anima.webp'
import BenefitImage10 from '../../assets/benefits/grido.webp'
import BenefitImage11 from '../../assets/benefits/aikido.webp'
import BenefitImage12 from '../../assets/benefits/entropia.webp'
import ContactForm from '../../components/ContactForm'
// import ViditaImage from '../../assets/brand/vidita.webp'
import ArrowRightIcon from '../../assets/icons/ArrowRightIcon'
import WorkWithUs from '../../containers/WorkWithUs'
import Logo from '../../components/Logo'
import ArticleCard from '../../components/ArticleCard'
import { ARTICLES } from '../../constants'


const BENEFITS = [
  {
    title: '2x1 Ahimsa Espacio',
    description: '2x1 en el primer mes de clases de Yoga o 25% de descuento en el primer mes.Claudio de Arrendondo 4265 - B° Villa Centenario, Zona Norte.',
    image: BenefitImage4
  },
  {
    title: 'Parma',
    description: '20% de descuento en los mejores sandwiches.',
    image: BenefitImage5
  },
  {
    title: '- 10% Volver a Casa Espacio Integral',
    description: '10% en compra de Gift Card, servicios de Spa, Talleres, Cursos y Clases. Juan Ochoa Zárate 1150 - Bajo Palermo.',
    image: BenefitImage6
  },
  {
    title: 'Chía',
    description: '15% de descuento en la carta.',
    image: BenefitImage3
  },
  {
    title: 'Chill out',
    description: '25% de descuento en la membresía online "bienestar on demand".',
    image: BenefitImage7
  },
  {
    title: 'La vianderita',
    description: '20% de descuento en el menú del día y toda la carta.',
    image: BenefitImage8
  },
  {
    title: 'Anima',
    description: '10% de de descuento en interpretación de revo solar o 10% de descuento en cursos online de tarot y astrología',
    image: BenefitImage9
  },
  {
    title: 'Grido',
    description: '15% de descuento.',
    image: BenefitImage10
  },
  {
    title: 'Aikido kannagara dojo',
    description: '20% de descuento en taller de aikido.',
    image: BenefitImage11
  },
  {
    title: 'Entropía',
    description: '10% de descuento en menú de la carta.',
    image: BenefitImage12
  },
  {
    title: 'WIN Fitness Challenge',
    description: '20% de descuento en el primer mes de servicio de musculación, funcional, zumba ,aerobox, gap, squash, localizada y body pump. *Abonando en efectivo',
    image: BenefitImage2
  },
]

const REVIEWS = [
  {
    description: 'Excelente organización del evento de fin de año para nuestra empresa. Gracias a Stefano y todo su equipo por tanto trabajo y dedicación. El jardín quedó increible, gracias por preparar todo para que disfrutemos de un lugar y un sunset único!',
    name: 'Ana Gabriela Canuto'
  }, {
    description: 'Organice mi casamiento en Vida Wast, un lugar verdaderamente mágico que superó todas nuestras expectativas. La vista es impresionante, la fuente, cada rincón decorado con plantas, realmente una belleza. Quisiera hacer una mención especial a Anto y Sofi, las chicas encargadas de la organización, siempre dispuestas, amables y atentas. Se encargaron de coordinar a todos los proveedores de manera impecable, asegurándose que todo saliera perfecto en nuestro evento de 110 personas. Su dedicación y profesionalismo garantizaron que tuviéramos una experiencia inolvidable.',
    name: 'Fabiana Serra'
  }, {
    description: 'La semana pasada organizamos un evento con ellos de 60 personas y todo fue excelente. Desde el comienzo se manejaron de forma amable y muy profesional. Garantizaron y se ocuparon de todo lo necesario para que fuera una experiencia genial. Definitivamente volveríamos a trabajar con ellos!',
    name: 'Ricardo H'
  }, {
    description: 'Increíble lugar. Cada espacio con el que contamos fue espectacular. Y la atención del personal también, excelente. Vamos a volver a disfrutar de este maravilloso lugar porque quedamos todos enamorados',
    name: 'Gabriela Diaz Assefh'
  }
]

const Community = () => {
  return (
    <>
      <Helmet>
        <title>Vida Cowork: Eventos</title>
      </Helmet>
      <main className="Community">
        <Banner
          title='Comunidad'
          description='Fomentamos conexiones auténticas que generan oportunidades, beneficios y experiencias enriquecedoras.'
          message='¡Hola! Quisiera realizar un día de prueba en Vida'
          whatsappIconLeft
        />

        <section className="Community__Info container-custom">
          <div className="d-flex flex-column gap-3">
            <span className='title-2 text-green fw-medium'>
              Eventos y experiencias únicas
            </span>
            <span className='text-5'>
              Generamos espacios de encuentro donde la innovación, el bienestar y la colaboración se unen para inspirar y fortalecer conexiones genuinas. A través de charlas, workshops y encuentros exclusivos, creamos experiencias que aportan valor, impulsan el crecimiento y alinean a las marcas aliadas con nuestra comunidad.
            </span>
          </div>

          <img
            className='Community__Info-Image'
            src={MainImage}
            alt="Vida Cowork"
            title="Vida Cowork"
          />
        </section>

        <section className="Community__Events">
          <div className='Community__Events-Container container-custom'>
            <span className='title-2 text-green text-center'>Nuevos artículos de nuestra comunidad</span>
            {/* <div className='Community__Events-Vidita'>
              <span className='title-2 text-green text-center'>Nuevo artículo de nuestra comunidad</span>
              <img
                src={ViditaImage}
                alt='Vida Cowork'
                title='Vida Cowork'
              />
              <Logo className='Community__Events-Logo'/>
            </div> */}

            <div className='Community__Events-Items'>
              {ARTICLES.map((article, index) => (
                <ArticleCard
                  key={`ArticleCard-${index}`}
                  title={article.title}
                  image={article.image}
                  category={article.category}
                  description={article.description}
                  link={article.link}
                />
              ))}
            </div>
          </div>
        </section>


        <section className="Community__Benefits-Container container-fluid">
          <div className="Community__Benefits-Tramas"></div>

          <div className="Community__Benefits container-custom">
            <div className="d-flex flex-column gap-3 text-center">
              <span className='caption z-1'>Beneficios de Vida Cowork</span>
              <span className='text-4 z-1'>¡Un plus! Siendo parte podés acceder a estos servicios</span>
            </div>

            <div className="Community__Benefits-Grid">
              {BENEFITS.map((benefit, index) => (
                <div
                  key={`Community-Benefit-${index}`}
                  className="Community__Benefits-Item"
                >
                  <img
                    className='Community__Benefits-Image'
                    src={benefit.image}
                    alt='Vida Cowork'
                    title='Vida Cowork'
                  />

                  <div className="d-flex flex-column gap-3">
                    <span className='text-2 text-green fw-bold'>
                      { benefit.title }
                    </span>
                    <span className='text-5 text-gray-dark'>
                      { benefit.description }
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="Community__Reviews container-custom">
          {/* Desktop/Tablet Carousel */}
          <div className="d-none d-md-block">
            <Swiper
              className='Community__Reviews-Swiper'
              modules={[ Autoplay ]}
              slidesPerView={1.5}
              spaceBetween={16}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false
              }}
              loop
              speed={1500}
              breakpoints={{
                768: {
                  slidesPerView: 2
                },
                992: {
                  slidesPerView: 3
                },
                1200: {
                  slidesPerView: 3.5,
                  spaceBetween: 24
                }
              }}
            >
              {REVIEWS.map((event, index) => (
                <SwiperSlide key={`Community-Review-${index}`}>
                  <div className="Community__Reviews-Item">
                    <span className='text-5 text-green'>
                      { event.description }
                    </span>

                    <div className="d-flex align-items-center gap-3">
                      <div className="d-flex flex-column">
                        <span className='text-4 text-gray-dark fw-medium'>
                          { event.name }
                        </span>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* Mobile Stacked Cards */}
          <div className="d-md-none">
            <div className="Community__Reviews-Mobile">
              {REVIEWS.map((event, index) => (
                <div key={`Community-Review-Mobile-${index}`} className="Community__Reviews-Item mb-3">
                  <span className='text-4 text-green'>
                    { event.description }
                  </span>

                  <div className="d-flex align-items-center gap-3">
                    <div className="d-flex flex-column">
                      <span className='text-3 text-gray-dark fw-medium'>
                        { event.name }
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <WorkWithUs/>

        <ContactForm/>
      </main>
    </>
  )
}

export default Community
